import GoAiguaModal from "components/generic/goaiguamodal";
import { useEffect, useState } from "react";
import { getRoleGroups } from "services/requests/v1/user";
import {
    GoAiguaSelectOption,
    SetRequestError,
    SubscribeContentType,
    UnsubscribeContentType,
} from "types/generic";
import UserAssigmentGroup from "./userassigmentgroup";
import UserAssigmentRole from "./userassigmentrole";

import { useIntl } from "react-intl";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { isTokenKCApiExpired } from "utils/functions";
import { useKeycloak } from "@react-keycloak/web";

type UserAssigmentModalType = {
    provenance: string;
    openModal: boolean;
    userUid?: string;
    token: string;
    setOpenModal: (openModal: boolean) => void;
    subscribeContent: SubscribeContentType;
    unsubscribeContent: UnsubscribeContentType;
    setError: SetRequestError;
};

const UserAssigmentModal = ({
    provenance,
    openModal,
    userUid,
    token,
    setOpenModal,
    setError,
    subscribeContent,
    unsubscribeContent,
}: UserAssigmentModalType) => {
    const intl = useIntl();

    const [modeSelected, setModeSelected] = useState<"group" | "role">("group");

    const [availableGroups, setAvailableGroups] = useState<
        GoAiguaSelectOption[]
    >([]);

    useEffect(() => {
        openModal &&
            getRoleGroups(provenance).then((res) => {
                setAvailableGroups(
                    res.data.map((group: any) => {
                        return {
                            label: group.name,
                            value: group.id,
                        };
                    })
                );
            });
    }, [provenance, openModal]);

    const {
        keycloak,
    }: {
        initialized: boolean;
        keycloak: Keycloak.KeycloakInstance;
    } = useKeycloak();

    useEffect(() => {
        if (isTokenKCApiExpired(token)) {
            keycloak.logout();
        }
    }, [token, openModal, provenance, modeSelected]);

    const groupAndRoleSelector = () => {
        return (
            <div className={"c-user-assigment__selector"}>
                <div className={"c-user-assigment__selector__radio-label"}>
                    <input
                        onChange={(e) => setModeSelected("group")}
                        className={"c-user-assigment__selector__radio-button"}
                        type="radio"
                        value={"group"}
                        name="nodetype"
                        checked={modeSelected === "group"}
                    />
                    {intl.formatMessage({ id: "app.Components.Roles.Group" })}
                </div>
                <div className={"c-user-assigment__selector__radio-label"}>
                    <input
                        onChange={(e) => setModeSelected("role")}
                        className={"c-user-assigment__selector__radio-button"}
                        type="radio"
                        value={"role"}
                        name="nodetype"
                        checked={modeSelected === "role"}
                    />
                    {intl.formatMessage({ id: "app.Components.Roles.Roles" })}
                </div>
            </div>
        );
    };

    return (
        <GoAiguaModal
            headerTitle={intl.formatMessage({
                id: "app.Components.Roles.GroupRoleAssignment",
            })}
            isOpen={openModal}
            setIsOpen={setOpenModal}
            className={"c-user-assigment__modal"}
        >
            {groupAndRoleSelector()}
            {modeSelected === "group" ? (
                <UserAssigmentGroup
                    availableGroups={availableGroups}
                    userUid={userUid}
                    provenance={provenance}
                    setOpenModal={setOpenModal}
                    subscribeContent={subscribeContent}
                    unsubscribeContent={unsubscribeContent}
                    setError={setError}
                />
            ) : (
                <UserAssigmentRole
                    availableGroups={[
                        {
                            label: intl.formatMessage({
                                id: "app.Component.Roles.Nothing",
                            }),
                            value: "-1",
                        },
                    ].concat(availableGroups)}
                    provenance={provenance}
                    userUid={userUid}
                    setOpenModal={setOpenModal}
                    setAvailableGroups={setAvailableGroups}
                    subscribeContent={subscribeContent}
                    unsubscribeContent={unsubscribeContent}
                    setError={setError}
                />
            )}
        </GoAiguaModal>
    );
};

const mapStateToProps = (state: any) => {
    return {
        token: state.keycloak.token,
    };
};
const mapDispatchToProps = (dispatch: Dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAssigmentModal);
